export interface ErrorNotice {
  message: string;
}

export function errorMessage(error: unknown, fallback = 'That action failed. Please try again.'): string {
  return error instanceof Error && error.message ? error.message : fallback;
}

/** Surface a caught async failure without coupling page code to toast UI. */
export function reportError(error: unknown, fallback?: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<ErrorNotice>('ss:error', {
      detail: { message: errorMessage(error, fallback) },
    }),
  );
}
